<template>
  <v-app-bar app elevation="0" :height="headerHeight">
    <div class="survey-header">
      <img :src="getLogo" alt="Logo da loja" class="survey-header-logo" />
    </div>
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SurveyHeader',
  computed: {
    ...mapGetters(['GET_ASSETS']),
    getLogo() {
      return this.GET_ASSETS.images.form.smartphone
    },
    headerHeight() {
      return this.$vuetify.breakpoint.xs ? '54px' : '80px'
    }
  }
}
</script>

<style scoped lang="scss">
:deep(.v-toolbar__content) {
  padding: 0 !important;
}

.survey-header {
  background-color: white;
  border-bottom: 1px solid #c3c8cd;
  padding: 0 24px;
  height: 100%;
  width: 100%;
}

.survey-header-logo {
  height: 100%;
  width: auto;
  object-fit: contain;
  padding: 8px;
}
</style>
